"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageRedirectComponent = exports.LastProjectStorage = void 0;
const React = __importStar(require("react"));
const ProjectsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectsDataProvider");
const CurrentPageProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentPageProvider");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const lodash_1 = __importDefault(require("lodash"));
const react_router_dom_1 = require("react-router-dom");
const KeyValueStoreFacade_1 = require("src/configeek_assets/src/system/store/KeyValueStoreFacade");
exports.LastProjectStorage = (function (store) {
    const KEY_PROJECT = "project";
    const isValidString = (value) => lodash_1.default.isString(value) && !lodash_1.default.isEmpty(value);
    const getProjectApiKey = () => {
        const value = store.get(KEY_PROJECT);
        if (isValidString(value)) {
            return value;
        }
        return undefined;
    };
    const setProjectApiKey = (value) => {
        if (isValidString(value)) {
            store.set(KEY_PROJECT, value);
        }
    };
    const clear = () => store.clearAll();
    return {
        getProjectApiKey,
        setProjectApiKey,
        clear
    };
})(KeyValueStoreFacade_1.KeyValueStoreFacade.createStore("configeek-last_project-store--"));
const PageRedirectComponent = (props) => {
    const { page: currentPage } = (0, CurrentPageProvider_1.useCurrentPageContext)();
    const projectsDataContext = (0, ProjectsDataProvider_1.useProjectsDataContext)();
    const { inProgress: projectsInProgress, loaded: projectsLoaded } = projectsDataContext.projectsCumulativeInfo.status;
    let redirectToUrl = undefined;
    // console.log("PageRedirectComponent.render: currentPage", currentPage);
    if (!projectsInProgress && projectsLoaded) {
        //projects loaded
        if (currentPage.identifier === "home" && currentPage.isExact) {
            /*
            is exact home page
            1. restore the latest project and check if it exists -> then redirect into it
            2. if no latest project - redirect to first from the list.
            */
            const storedLastProjectApiKey = exports.LastProjectStorage.getProjectApiKey();
            if (storedLastProjectApiKey) {
                // console.log("PageRedirectComponent: there is storedLastProjectApiKey:", storedLastProjectApiKey);
                if (projectsDataContext.hasProjects()) {
                    const foundProject = projectsDataContext.getProject(storedLastProjectApiKey);
                    if (foundProject) {
                        // console.log("PageRedirectComponent: redirect to found project");
                        redirectToUrl = AppRouter_1.PathGenerator.project(foundProject.view.project.projectApiKey);
                    }
                    else {
                        // console.log("PageRedirectComponent: project not found by storedLastProjectApiKey -> choose first one");
                        const lastCreatedProject = projectsDataContext.getLastCreatedProject();
                        if (lastCreatedProject) {
                            redirectToUrl = AppRouter_1.PathGenerator.project(lastCreatedProject.view.project.projectApiKey);
                        }
                    }
                }
                else {
                    //no projects - clear storage
                    // console.log("PageRedirectComponent: no projects - clear storage");
                    exports.LastProjectStorage.clear();
                }
            }
            else {
                if (projectsDataContext.hasProjects()) {
                    // console.log("PageRedirectComponent: no storedLastProjectApiKey -> choose first one");
                    const lastCreatedProject = projectsDataContext.getLastCreatedProject();
                    if (lastCreatedProject) {
                        redirectToUrl = AppRouter_1.PathGenerator.project(lastCreatedProject.view.project.projectApiKey);
                    }
                }
            }
        }
        else if (currentPage.identifier === "project") {
            /*
            is project pages

            reset storedLastProjectApiKey value
            */
            const foundProject = projectsDataContext.getProject(currentPage.projectApiKey);
            if (!foundProject) {
                exports.LastProjectStorage.clear();
                return React.createElement(react_router_dom_1.Redirect, { to: AppRouter_1.PATH__HOME });
            }
            // console.log("PageRedirectComponent: set storedLastProjectApiKey to", foundProject.view.project.projectApiKey);
            exports.LastProjectStorage.setProjectApiKey(foundProject.view.project.projectApiKey);
        }
        if (redirectToUrl) {
            // console.log("PageRedirectComponent: render redirect");
            return React.createElement(react_router_dom_1.Redirect, { to: redirectToUrl });
        }
    }
    return React.createElement(React.Fragment, null, props.children);
};
exports.PageRedirectComponent = PageRedirectComponent;
